class FullWidthMedia extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // 获取元素
        this.parentMedia = this.querySelector('.full-width-media-gallery__swiper');
        this.thumbMedia = this.querySelector('.full-width-media-thumb__swiper');

        // 初始化 swiper 实例
        this.initializeThumbSwiper();
        this.initializeParentSwiper();
    }
    // 初始化 thumbSwiper
    initializeThumbSwiper() {
        if (this.thumbMedia) {
            this.thumbSwiper = new Swiper(this.thumbMedia, {
                slidesPerView: 6,
                spaceBetween: 13,
                watchSlidesVisibility: true,
                breakpoints: { 
                    320: {  //当屏幕宽度大于等于320
                      slidesPerView: 4,
                    },
                    749: {  //当屏幕宽度大于等于768 
                      slidesPerView: 6,
                    },
                  }
            });
        }
    }
    // 初始化 parentSwiper
    initializeParentSwiper() {
        if (this.parentMedia) {
            this.parentSwiper = new Swiper(this.parentMedia, {
                spaceBetween: 20,
                autoHeight: true,
                thumbs: {
                    swiper: this.thumbSwiper,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
    }
}

customElements.define('full-width-media', FullWidthMedia);
